import Swiper, { Pagination } from 'swiper';

const SwiperImageTextQuote = function () {
  
  // configure Swiper to use modules
  Swiper.use( Pagination );
  const els = document.querySelectorAll( '.swiper-image-text-quote' );

  // loop through swiper sections and init Swiper
  if ( Object.keys(els).length ) {
    els.forEach( function( el ){
      const pagination = el.querySelector( '.swiper-pagination');
      const swiper = new Swiper( el , {
        direction: 'horizontal',
        spaceBetween: 30,
        slidesPerView: 1,
        centeredSlides: true,
        initialSlide: 0,
        loop: false,
        preventClicks: true,
        pagination: {
          el: pagination,
          clickable: true
        }
      })
    });
  }

}

export default SwiperImageTextQuote;